import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import { tableHeaderStyles, tableCellStyles } from "../../../../utils/styles";

const MasterSkeleton: React.FC<{ fields: string[] }> = ({ fields }) => (
  <Box >
    {/* Navigation Header Skeleton */}
    <Box
      sx={{
        mb: 2,
        display: "flex",
        flexDirection: "row",
        gap: 1,
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Skeleton variant="text" width={300} height={25} />
        <Skeleton variant="text" width={200} height={15} />
      </Box>
      {/* 2 button on the right */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Skeleton variant="text" width={100} height={40} />
        <Skeleton variant="text" width={100} height={40} />
      </Box>
    </Box>

    {/* Table Skeleton */}
    <TableContainer component={Paper}>
      <Table size="small" aria-label="garages table skeleton">
        <TableHead>
          <TableRow>
            {fields.map((field) => (
              <TableCell
                {...tableHeaderStyles}
                sx={{ color: "text.secondary", fontSize: "0.8rem" }}
              >
                {field}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(4)].map((_, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { backgroundColor: "action.hover" },
              }}
            >
              {fields.map((field, idx) => (
                <TableCell {...tableCellStyles} key={index}>
                  {idx === fields.length - 1 ? (
                    <Box sx={{ display: "flex", gap: 1, flexDirection: "row" }}>
                      <Skeleton variant="text" width="40%" height={30} />
                      <Skeleton variant="text" width="40%" height={30} />
                    </Box>
                  ) : (
                    <Skeleton variant="text" width="80%" height={16} />
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default MasterSkeleton;
